import { fetchAuthSession } from 'aws-amplify/auth'

import { Auth } from '../amplify'
import decodeJwtToken from 'civic-champs-shared/auth/utils/decodeJwtToken'

// Amplify v6 can expose tokens via fetchAuthSession before getCurrentUser() is ready on cold start.
const AUTH_SESSION_RETRY_ATTEMPTS = 10
const AUTH_SESSION_RETRY_DELAY_MS = 150

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function mapHubEventToUser(event) {
  const attrs = event.payload.data.attributes

  let permissions
  try {
    permissions = JSON.parse(attrs['custom:permissions'])
  } catch (error) {
    permissions = {
      role: 'USER',
      managedOrganization: null,
    }
  }

  return {
    cognitoSub: attrs.sub,
    givenName: attrs.given_name,
    familyName: attrs.family_name,
    email: attrs.email,
    phone: attrs.phone || attrs.alt_phone,
    permissions,
  }
}

function userFromTokenPayload(payload) {
  if (!payload?.sub) {
    return null
  }
  return mapHubEventToUser({ payload: { data: { attributes: payload } } })
}

async function userFromAmplifySession() {
  try {
    const session = await fetchAuthSession()
    return userFromTokenPayload(session.tokens?.idToken?.payload)
  } catch (error) {
    return null
  }
}

export async function getCurrentAuthenticatedUser() {
  try {
    const userInfo = await Auth.currentAuthenticatedUser()
    return mapHubEventToUser({ payload: { data: userInfo } })
  } catch (error) {
    const fromSession = await userFromAmplifySession()
    if (fromSession) {
      return fromSession
    }

    try {
      const token = localStorage.getItem('token')
      const userInfo = decodeJwtToken(token)
      return mapHubEventToUser({ payload: { data: { attributes: userInfo } } })
    } catch (innerError) {}
    return null
  }
}

export async function resolveAuthenticatedUserWithRetry() {
  for (let attempt = 1; attempt <= AUTH_SESSION_RETRY_ATTEMPTS; attempt++) {
    const user = await getCurrentAuthenticatedUser()
    if (user) {
      return { user, attempts: attempt }
    }

    if (attempt < AUTH_SESSION_RETRY_ATTEMPTS) {
      await delay(AUTH_SESSION_RETRY_DELAY_MS * attempt)
    }
  }

  return { user: null, attempts: AUTH_SESSION_RETRY_ATTEMPTS }
}
